import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PaymentService } from './payment.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import html2canvas from 'html2canvas';
import { Location } from '@angular/common';
import { of } from 'rxjs';
import THBText from 'thai-baht-text'
import { Logo } from 'src/app/shared/logo-encode';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import { PaymentManagementService } from '../payment-management/payment-management.service';
import pdfMake from 'pdfmake/build/pdfmake';
import { LogoChulaBlackWhite } from 'src/app/shared/logo-chula-black-white';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { WaterMark } from 'src/app/shared/water-mark';
import { OldChulaLogo_Base64 } from 'src/app/shared/old-chula-logo-base64';
import { Signature } from 'src/app/shared/signature';
import { AccountingService } from '../accounting/accounting.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  qrcode: boolean = false;
  transfer: boolean = false;
  credit: boolean = false;
  paymentForm
  isLoading: boolean = false;

  type;
  id;
  body;
  payment;
  statusPayment;
  paymentType;

  billerForm;
  bill: boolean = false;

  // for QR
  amount;
  expQR;
  merchantName;
  qrID;
  qrBase64;
  qrStatus: boolean;
  checkQrPaymentStatus;
  checkQRStatus: boolean = true;
  statusMessage: string;

  accountId: string = '';
  account: any;
  isPrint: boolean = false;
  receiptDetail: any;

  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private paymentService: PaymentService,
    private _location: Location,
    private paymentManagementService: PaymentManagementService,
    private gobalFunctionService: GobalFunctionService,
    private jwtHelper: JwtHelperService,
    private accountService: AccountingService
  ) {
    this.billerForm = fb.group({
      name: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern("(^02[0-9]{7}$)|(^06[0-9]{8}$)|(^08[0-9]{8}$)|(^09[0-9]{8}$)")]],
      address: [''],
      tax: ['', [Validators.pattern("(^[0-9]{13}$)")]]
    })
  }

  ngOnInit(): void {

    this.id = new URL(location.href).searchParams.get('id');
    this.type = new URL(location.href).searchParams.get('type');
    this.gobalFunctionService.setTitle('ชำระเงิน');

    this.body = {
      ID: this.id,
      TYPE: this.type
    }

    this.isLoading = true;
    this.paymentService.createPayment(this.body).pipe(
      switchMap(res => {
        this.payment = res.result;
        // console.log(this.payment);
        const body = {
          PAYMENT_ID: this.payment.PAYMENT_ID
        }

        return this.paymentService.scbInquiry(body).pipe(
          switchMap(scb => {

            return this.paymentService.getStatusPaymentById(this.payment.PAYMENT_ID).pipe(
              map(status => {
                console.log(status);
                this.accountId = status.result[0].ACCOUNTING_ID;
                setTimeout(() => {
                  this.isLoading = false;
                }, 500);

                this.statusPayment = status.result[0];
                // console.log(status);
                if (this.payment.FREE || this.statusPayment.STATUS_PAYMENT === 'success') {
                  this.createReceipt();
                } else {
                  if (this.statusPayment.STATUS_PAYMENT === 'waiting_confirm') {
                    alert('ธุรกรรมอยู่ระหว่างการดำเนินการตรวจสอบ');
                    this.router.navigate(['/']);
                    return of(null);
                  } else {
                    // // console.log(status.result);
                    // this.statusPayment = status.result[0];
                    this.getActiveAccount()
                  }
                }
              })
            )
          })
        )

      }),
      catchError((err) => {
        // console.log(err);
        alert('ไม่สามารถทำรายการได้ในขณะนี้ โปรดำเนินการใหม่อีกครั้ง');
        this.router.navigate(['/']);
        return of(false);
      })
    ).subscribe();

  }

  getActiveAccount() {
    this.accountService.getActiveAccount().pipe(
      map(a => {
        // console.log(a.result);
        // this.account = a.result;
        a.result.forEach(e => {
          if (e.ACCOUNTING_ID === this.accountId) {
            this.account = e;
            // console.log(this.account);
          }
        });
      })
    ).subscribe();
  }

  transferClick() {
    let paymentID = this.payment.PAYMENT_ID;
    let price = this.payment.PRICE;
    let form = this.billerForm

    this.paymentService.getDataFormPayment(form);

    const queryParams: Params = { paymentID: paymentID, price: price, };
    this.router.navigate(
      ['/transfer'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });

  }

  transferType(type) {
    console.log(type);
    this.paymentType = type;
    switch (type) {
      case 'qrcode': {
        this.credit = false;
        this.qrcode = true;
        this.transfer = false;

        this.createQRPayment(this.billerForm, this.payment.PAYMENT_ID, this.payment.PRICE);
        break;
      }
      case 'bank': {
        this.credit = false;
        this.qrcode = false;
        this.transfer = true;
        break;
      }
      case 'credit': {
        this.credit = true;
        this.qrcode = false;
        this.transfer = false;
        this.createCreditPayment(this.billerForm, this.payment.PAYMENT_ID, this.payment.PRICE);
        break;
      }
    }

    // this.createReceipt();
  }

  checkStatus(pid) {
    const body = {
      PAYMENT_ID: pid
    }

    this.paymentService.scbInquiry(body).pipe(
      switchMap(scb => {

        return this.paymentService.getStatusPaymentById(pid).pipe(
          map(res => {
            // // console.log(res);
            if (res.success) {
              // this.createReceipt();
              this.checkQrPaymentStatus = res.result[0].STATUS_PAYMENT;

              if (this.checkQrPaymentStatus === 'waiting_pay') {
                this.checkQRStatus = false;
                // นับเวลาถอยหลัง 30 วิ function handleEvent จัดการสถานะเอง
              } else if (this.checkQrPaymentStatus === 'success') {
                // this.createReceipt();
                if (this.type === 'report') {
                  window.open(`/payment-success?pid=${pid}&id=${this.id}&type=${this.type}&template=${this.payment.TEMPLATE_TYPE}&mid=${this.payment.MEASURE_ID}&ACCOUNTING_ID=${this.accountId}`, '_self');
                } else {
                  window.open(`/payment-success?pid=${pid}&id=${this.id}&type=${this.type}&ACCOUNTING_ID=${this.accountId}`, '_self');
                }

              }

            }
          })
        )
      }),
      catchError((err) => {
        alert('ไม่สามารถทำรายการได้ในขณะนี้ โปรดำเนินการใหม่อีกครั้ง');
        this.router.navigate(['/']);
        return of(false);
      })
    ).subscribe();
  }

  handleEvent(event) {
    if (event.left === 0) {
      this.checkQRStatus = true;
    }
  }

  downloadImage(title) {
    var container = document.getElementById("download");
    html2canvas(container, { allowTaint: true }).then(function (canvas) {

      var link = document.createElement("a");
      document.body.appendChild(link);
      link.download = `${title}.jpg`;
      link.href = canvas.toDataURL();
      link.target = '_blank';
      link.click();

    });
  }

  createQRPayment(billerForm, pid, price) {
    // // console.log(billerForm);
    // // console.log(pid);
    let body = {
      PAYMENT_ID: pid,
      NAME: billerForm.value.name,
      ADDRESS: billerForm.value.address,
      TAX_NO: billerForm.value.tax,
      PHONENUMBER: billerForm.value.phone,
      PRICE: price.toString()
    }
    this.isLoading = true;

    this.paymentService.createQRPayment(body).pipe(
      map(res => {
        if (res.success) {
          this.isLoading = false;
          this.qrStatus = true;
          // // console.log(res);
          this.amount = res.result.AMOUNT;
          this.expQR = res.result.EXP_QR;
          this.merchantName = res.result.MERCHANT_NAME;
          this.qrID = res.result.QRID;
          this.qrBase64 = `data:image/png;base64,${res.result.QR_BASE64}`;
          // // console.log(res);

          // this.createReceipt();
        } else {
          this.isLoading = false;
          this.qrStatus = false;
          alert('ไม่สามารถทำรายการได้')
          return of(null);
        }

      }),
      catchError((err) => {
        this.qrStatus = false;
        alert('ไม่สามารถทำรายการได้โปรดลองอีกครั้งภายหลัง');
        setTimeout(() => {
          location.reload();
        }, 100);
        return of(false);
      })
    ).subscribe();

    // // console.log(body);
  }

  createCreditPayment(billerForm, pid, price) {

    var redirect_link = '';

    if (this.type === 'report') {
      redirect_link = `https://chulalifedi.com/payment-success?pid=${pid}&id=${this.id}&type=${this.type}&template=${this.payment.TEMPLATE_TYPE}&mid=${this.payment.MEASURE_ID}&ACCOUNTING_ID=${this.accountId}`;
    } else {
      redirect_link = `https://chulalifedi.com/payment-success?pid=${pid}&id=${this.id}&type=${this.type}&ACCOUNTING_ID=${this.accountId}`;
    }

    let body = {
      PAYMENT_ID: pid,
      NAME: billerForm.value.name,
      ADDRESS: billerForm.value.address,
      TAX_NO: billerForm.value.tax,
      PHONENUMBER: billerForm.value.phone,
      PRICE: price.toString(),
      FRONTEND_REDIRECT: redirect_link
    }
    this.isLoading = true;

    this.paymentService.create2c2pPayment(body).pipe(
      map(res => {
        // this.createReceipt();
        setTimeout(() => {
          this.isLoading = false;
          window.open(`${res.result.webPaymentUrl}`, '_self');
        }, 2000);
      }),
      catchError((err) => {
        alert('ไม่สามารถทำรายการได้โปรดลองอีกครั้งภายหลัง');
        setTimeout(() => {
          location.reload();
        }, 100);
        return of(false);
      })
    ).subscribe();


  }


  validate() {
    console.log('aaa');
    var form = document.getElementsByClassName('needs-validation')[0] as HTMLFormElement;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    form.classList.add('was-validated');
  }

  onChange(e) {
    // // console.log(e);
    if (e.key) {
      this.qrcode = false;
      this.transfer = false;
    }
  }

  createReceipt() {
    let receipt;
    let today = new Date();

    this.paymentManagementService.getSignature().pipe(
      map(res => {
        // // console.log(res);
        if (res.success) {

          receipt = {
            address: `จุดรับเงิน: คณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย
            อาคารบรมราชชนนีศรีศตพรรษ ชั้น 7 แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330
            โทรศัพท์: 02-218-1185 โทรสาร: 02-218-1339 เลขที่ผู้เสียภาษี: 0994000163860 สาขา: 3800`,
            thbath: this.statusPayment.PRICE > 0 ? THBText(this.statusPayment.PRICE) : 'ฟรี',
            discount: this.statusPayment.PRICE === this.statusPayment.STANDARTPRICE ? 0 : this.statusPayment.STANDARTPRICE - this.statusPayment.SPECIALPRICE,
            price: this.statusPayment.REMARK_PRICE ? this.statusPayment.REMARK_PRICE : this.statusPayment.PRICE,
            standardPrice: this.statusPayment.STANDARTPRICE,
            specialPrice: this.statusPayment.SPECIALPRICE,
            type: this.paymentType === 'credit' ? 'บัตรเครดิต/เดบิต' : 'เงินโอน',
            paymentID: this.statusPayment.PAYMENT_ID,
            signaturePic1: Signature[0].signature,
            signatureName1: Signature[0].signatureName,
            signatureJobTitle1: Signature[0].position,
            signaturePic2: Signature[1].signature,
            signatureName2: Signature[1].signatureName,
            signatureJobTitle2: Signature[1].position,
            userName: this.billerForm.value.name,
            userAddress: this.billerForm.value.address,
            taxID: this.billerForm.value.tax,
            userPhone: this.billerForm.value.phone,
            date: new DatePipe().transform(today.toString(), 'full'),
            bankDate: today,
            printDate: `${new DatePipe().transform(today.toString(), 'full')} - ${today.getHours() > 9 ? '' : 0}${today.getHours()}:${today.getMinutes() > 9 ? '' : 0}${today.getMinutes()}น.`,
            paymentName: this.payment.TITLE,
            receiptId: this.statusPayment.RECEIPT_ID,
          }

          this.receiptDetail = receipt;
          this.isPrint = true;
          setTimeout(() => {
            this.isPrint = false;
          }, 1000);
        }
      }),
      catchError((err) => {
        alert(err);
        return of(null);
      })
    ).subscribe();


  }

  sendMail(e) {
    let body = {
      PAYMENT_ID: this.payment.PAYMENT_ID,
      TRANS_ID: this.statusPayment.Detail[this.statusPayment.Detail.length - 1].TRANS_ID,
      TYPE: this.paymentType === 'bank' ? 'TRANSFER' : this.paymentType === 'qrcode' ? 'SCB' : this.paymentType === 'credit' ? '2C2P' : 'TRANSFER',
      base64str: e,
    };
    // console.log(body);
    this.paymentService.saveBase64ReceiveBillSndMail(body).subscribe((res) => {
      // console.log(res);
      if (res.success) {
        if (this.payment.FREE || this.statusPayment.STATUS_PAYMENT === 'success') {
          if (this.type === 'report') {
            window.open('/test-report?type=' + this.payment.TEMPLATE_TYPE + '&paid=notfree' + '&mid=' + this.payment.MEASURE_ID + '&view_status=1&informant_type=0', '_self');
          } else {
            switch (this.type) {
              case 'course': {
                window.open('/e-learning/' + this.id, '_self');
                break;
              }

              case 'workshop': {
                window.open('/activity/workshop/' + this.id, '_self');
                break;
              }

              default: {
                break;
              }
            }
          }
        }
      }
    });
  }

}
